import { createFileRoute, redirect } from "@tanstack/react-router";

/** Kompatibilní URL — diagnostika se na public webu otevírá jako modal na homepage. */
export const Route = createFileRoute("/diagnoza")({
  beforeLoad: () => {
    throw redirect({ to: "/", search: { diagnostika: "1" } });
  },
});
